import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const RenterPreferencesModal = ({ isOpen, onClose, onSavePreferences }) => {
  const [preferences, setPreferences] = useState({
    propertyType: '',
    location: '',
    budgetMin: '',
    budgetMax: '',
    bedrooms: '',
    bathrooms: '',
    leaseDuration: '',
    moveInDate: '',
    furnishing: '',
    parking: false,
    pool: false,
    gym: false,
    petFriendly: false,
    balcony: false,
    numberOfOccupants: '',
    employmentStatus: '',
    notes: ''
  });

  const handleChange = (field, value) => {
    setPreferences(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckbox = (field) => {
    setPreferences(prev => ({ ...prev, [field]: !prev?.[field] }));
  };

  const handleSave = () => {
    onSavePreferences?.(preferences);
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="تفضيلات المستأجرين" 
      size="lg"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-4 max-h-[70vh] overflow-y-auto">
        <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 text-cyan-400">
            <Icon name="Home" size={20} />
            <span className="font-semibold">تحديد متطلبات الإيجار</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">نوع العقار</label>
            <Select
              value={preferences?.propertyType}
              onChange={(e) => handleChange('propertyType', e?.target?.value)}
            >
              <option value="">اختر النوع</option>
              <option value="apartment">شقة</option>
              <option value="villa">فيلا</option>
              <option value="studio">استوديو</option>
              <option value="townhouse">تاون هاوس</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">الموقع المفضل</label>
            <Input
              placeholder="مثال: الريم، أبوظبي"
              value={preferences?.location}
              onChange={(e) => handleChange('location', e?.target?.value)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الإيجار الشهري (دينار أردني)</label>
          <div className="grid grid-cols-2 gap-4">
            <Input
              type="number"
              placeholder="الحد الأدنى"
              value={preferences?.budgetMin}
              onChange={(e) => handleChange('budgetMin', e?.target?.value)}
            />
            <Input
              type="number"
              placeholder="الحد الأقصى"
              value={preferences?.budgetMax}
              onChange={(e) => handleChange('budgetMax', e?.target?.value)}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">غرف النوم</label>
            <Select
              value={preferences?.bedrooms}
              onChange={(e) => handleChange('bedrooms', e?.target?.value)}
            >
              <option value="">اختر العدد</option>
              <option value="studio">استوديو</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5+">5+</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">دورات المياه</label>
            <Select
              value={preferences?.bathrooms}
              onChange={(e) => handleChange('bathrooms', e?.target?.value)}
            >
              <option value="">اختر العدد</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4+">4+</option>
            </Select>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">مدة الإيجار</label>
            <Select
              value={preferences?.leaseDuration}
              onChange={(e) => handleChange('leaseDuration', e?.target?.value)}
            >
              <option value="">اختر المدة</option>
              <option value="6-months">6 أشهر</option>
              <option value="1-year">سنة واحدة</option>
              <option value="2-years">سنتان</option>
              <option value="3-years">3 سنوات</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">تاريخ الانتقال</label>
            <Input
              type="date"
              value={preferences?.moveInDate}
              onChange={(e) => handleChange('moveInDate', e?.target?.value)}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">الأثاث</label>
            <Select
              value={preferences?.furnishing}
              onChange={(e) => handleChange('furnishing', e?.target?.value)}
            >
              <option value="">غير محدد</option>
              <option value="furnished">مفروش</option>
              <option value="unfurnished">غير مفروش</option>
              <option value="semi-furnished">نصف مفروش</option>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">عدد السكان</label>
            <Input
              type="number"
              placeholder="عدد الأشخاص"
              value={preferences?.numberOfOccupants}
              onChange={(e) => handleChange('numberOfOccupants', e?.target?.value)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">الحالة الوظيفية</label>
          <Select
            value={preferences?.employmentStatus}
            onChange={(e) => handleChange('employmentStatus', e?.target?.value)}
          >
            <option value="">اختر الحالة</option>
            <option value="employed">موظف</option>
            <option value="self-employed">عمل حر</option>
            <option value="business-owner">صاحب عمل</option>
            <option value="retired">متقاعد</option>
            <option value="student">طالب</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">المرافق المطلوبة</label>
          <div className="grid grid-cols-2 gap-3">
            <Checkbox
              label="موقف سيارات"
              checked={preferences?.parking}
              onChange={() => handleCheckbox('parking')}
            />
            <Checkbox
              label="مسبح"
              checked={preferences?.pool}
              onChange={() => handleCheckbox('pool')}
            />
            <Checkbox
              label="صالة رياضية"
              checked={preferences?.gym}
              onChange={() => handleCheckbox('gym')}
            />
            <Checkbox
              label="يسمح بالحيوانات"
              checked={preferences?.petFriendly}
              onChange={() => handleCheckbox('petFriendly')}
            />
            <Checkbox
              label="شرفة"
              checked={preferences?.balcony}
              onChange={() => handleCheckbox('balcony')}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">ملاحظات إضافية</label>
          <textarea
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
            rows="3"
            placeholder="أي متطلبات أو تفضيلات إضافية..."
            value={preferences?.notes}
            onChange={(e) => handleChange('notes', e?.target?.value)}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleSave} className="flex-1">
            <Icon name="Save" size={18} className="ml-2" />
            حفظ التفضيلات
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RenterPreferencesModal;